import isUndefined from 'onyx-common/isUndefined'

const getCookieValue = (name, cookie) => {
  if (isUndefined(cookie)) cookie = document.cookie
  const ret = cookie.match(`(^|;)\\s${name}\\s*=\\s*([^;]+)`)
  return ret ? ret.pop() : undefined
}

export default getCookieValue
